import React, { useState, useEffect, useRef } from "react";
// import { useParams, Link } from "react-router-dom";
// import { Accordion } from 'react-bootstrap';

import Header from "../../../layout/header";
import Footer from "../../../layout/footer";


import bbanner from "../../../assets/img/banner-wearcare.png";
import wearcare from "../../../assets/img/wearcare1.jpg";

import Loading from "../../../components/loading";

const Main = () => {
    const [isLoading, setIsLoading] = useState(true);
    const [dataOne, setDataOne] = useState({});

    const called = useRef(true);

    useEffect(() => {
        if (called.current) {
            // Promise.all([fetchDataOne()]).then(
            //     (res) => {
            setTimeout(() => {
                setIsLoading(false);
            }, 500);
            //     }
            // );
        }
        return () => {
            called.current = false;
        };
    }, []);

    // const fetchDataOne = async () => {
    //     getData("pageawards", "waste")
    //         .then((response) => {
    //             if (response.status === "success") {
    //                 setDataOne(response.data)
    //             }
    //         })
    //         .catch((e) => {
    //             console.log(e.response.data.error);
    //         });
    // };

    return (
        <>
            <div id="outer-container" style={{}}>
                <Header page="activities" sub="partnership" />
                <div className="wrapper bg-white box-index">
                    {isLoading ? <Loading /> : null}
                    <section className="pb-md-5 bg-top">
                        <div className="container-fluid">
                            <div className="row justify-content-center text-start">
                                <div className="col-12 col-md-12 col-lg-12 p-0">
                                    <div className="">
                                        <img src={bbanner} className="w-100 rounded" alt="" />
                                    </div>
                                </div>
                                <div className="col-12 col-md-12 col-lg-9 mt-3 mt-md-4">
                                    <div className="font-50 weight-700">Wear and Care: Fashion the SEP Way</div>
                                    <div className="mb-5 pt-3">
                                        <div className="font-18 text-justify content-custom">
                                            <p>In celebration of the United Nations World Cleanup Day 2025, which this year focuses on fashion and textile waste, 44 schools from Southeast Asian countries and Bhutan enthusiastically organised a variety of activities promoting environmental responsibility. The week-long campaign, held from 15–20 September 2025, carried the theme “Wear and Care: Fashion the SEP Way.”</p>
                                            <p><br /></p>
                                            <p>Inspired by the Sufficiency Economy Philosophy (SEP), schools were encouraged to design simple yet creative initiatives that embody the values of moderation, resourcefulness, and shared responsibility. These activities aimed to empower students, teachers, parents, and community members to become mindful consumers and responsible global citizens, fostering a deeper understanding of how everyday choices—especially in fashion—can contribute to a more sustainable world.</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center py-3 py-md-5 text-start" style={{ background: "#FFDE59" }}>
                                <div className="col-11 col-md-9 col-lg-9">
                                    <div>
                                        <div><img src={wearcare} className="w-100" /></div>
                                    </div>
                                </div>
                            </div>
                            <div className="row justify-content-center">
                                <div className="col-12 col-md-12 col-lg-9 mt-3 mt-md-4 text-start">
                                    <div className="flex justify-center text-center my-4">
                                        <div className="ratio ratio-16x9 w-100 w-md-75 mx-auto">
                                            <iframe
                                                className="w-full h-full rounded-lg"
                                                src="https://www.youtube.com/embed/fRt0EE7qNh0?si=koteb0HgB40Ihqrt"
                                                title="YouTube video player"
                                                frameBorder="0"
                                                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                                referrerPolicy="strict-origin-when-cross-origin"
                                                allowFullScreen
                                            ></iframe>
                                        </div>
                                    </div>
                                    <div className="sub-topic weight-700 pt-4">List of Participating Schools</div>
                                    <div className="mt-3">
                                        <table class="table table-bordered">                                           
                                            <tbody>
                                                <tr><td>Jurmey Primary School, Bhutan</td><td>SM Sains Kuching, Malaysia</td></tr>
                                                <tr><td>Dorokha Primary School, Bhutan</td><td>SEKOLAH KEBANGSAAN DESA BAKTI, Malaysia</td></tr>
                                                <tr><td>Kidheykhar CS, Bhutan</td><td>SK HOLY TRINITY, Malaysia</td></tr>
                                                <tr><td>Sultan Muhammad Jamalul Alam Secondary School, Brunei Darussalam</td><td>Ilawod Elementary School, Philippines</td></tr>
                                                <tr><td>SMAN 2 CIKARANG SELATAN, Cambodia</td><td>Nambalan National High School, Philippines</td></tr>
                                                <tr><td>Kdol Public Secondary School, Cambodia</td><td>SAN LUIS NATIONAL HIGH SCHOOL, Philippines</td></tr>
                                                <tr><td>SMA Negeri 1 Tanggul, Indonesia</td><td>DEPED-ALTERNATIVE LEARNING SYSTEM, Philippines</td></tr>
                                                <tr><td>SMA SATU TANGGUL, Indonesia</td><td>Salvacion National High School, Philippines</td></tr>
                                                <tr><td>SMAN 1 PULUNG, Indonesia</td><td>SAN QUINTIN NATIONAL HIGH SCHOOL, Philippines</td></tr>
                                                <tr><td>SD NEGERI 3 PANCOR, Indonesia</td><td>INFANTA NATIONAL HIGH SCHOOL, Philippines</td></tr>
                                                <tr><td>SDN HEGARMANAH JATINANGOR SUMEDANG, Indonesia</td><td>Indang Integrated National High School, Philippines</td></tr>
                                                <tr><td>SMA Xaverius Bandar Lampung, Indonesia</td><td>Mariano Marcos State University Laboratory High School - Laoag, Philippines</td></tr>
                                                <tr><td>SMPN 110 Jakarta, Indonesia</td><td>VICENTA A. MANREAL ELEMENTARY SCHOOL, Philippines</td></tr>
                                                <tr><td>SDN 252 Setiabudi, Indonesia</td><td>Nakhonsawan Provincial Education Office, Thailand</td></tr>
                                                <tr><td>Muhammadiyah 13 Senior High School Jakarta, Indonesia</td><td>Tessabantakhli School, Thailand</td></tr>
                                                <tr><td>SD NEGERI BINTARO 12, Indonesia</td><td>Nakhonsawan Special Education Center, Thailand</td></tr>
                                                <tr><td>SK SEKSYEN 13, Malaysia</td><td>Thaicharoenwittaya School, Thailand</td></tr>
                                                <tr><td>ST PATRICK SECONDARY SCHOOL, Malaysia</td><td>Phasert School, Thailand</td></tr>
                                                <tr><td>SMJK PEREMPUAN PERAK, Malaysia</td><td>Nongkrod Pittayakom School, Thailand</td></tr>
                                                <tr><td>SJKC TONGKANG, Malaysia</td><td>Watklangdad School, Thailand</td></tr>
                                                <tr><td>SMK LA SALLE SENTUL, Malaysia</td><td>Photisansuksa School, Thailand</td></tr>
                                                <tr><td>SEKOLAH KEBANGSAAN SRI AMAR, Malaysia</td><td>Ban Tewaritphanluek School, Thailand</td></tr>
                                            </tbody>
                                        </table>

                                    </div>

                                </div>
                            </div>

                        </div>
                    </section>

                    <Footer page="activities" sub="partnership" />
                </div>
            </div>
        </>
    );
};

export default Main;
